export class AdTrackClient {
    constructor(config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
    }
    // ad-track.jpのサンクスページ用コンバージョンタグ
    // buidには注文番号などユーザーを特定できるユニークな値（本アプリではユーザーID）を渡す
    loadConversionScript(buid) {
        // 本番のみ計測する（stg/devの登録で広告ベンダーの計測データを汚さない）
        if (!this.config.isProduction)
            return;
        // 提供タグは<script src=cv.js>とinline<script>の同期実行順に依存している。
        // SPAでは動的scriptが非同期ロードになるため、loadイベントで実行順序を担保する。
        const script = document.createElement('script');
        script.src = 'https://ad-track.jp/ad/js/cv.js';
        script.addEventListener('load', () => {
            const w = window;
            if (w.adtrack_cv) {
                w.adtrack_cv.cv('adm_adtr_xuid', 'https://ad-track.jp/ad', `_buyer=31016&_article=26428&_buid=${buid}&key1=`);
            }
        });
        document.getElementsByTagName('body')[0].appendChild(script);
    }
}
